/* eslint-disable */
import CloseIcon from '@mui/icons-material/Close';
import {
    Autocomplete,
    Box,
    Breadcrumbs,
    Button,
    CardContent,
    Fab,
    InputAdornment,
    LinearProgress,
    Stack,
    Table,
    TableBody,
    TableContainer,
    TablePagination,
    TextField,
    Tooltip,
    Typography,
    useTheme
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ListingActions } from 'store/slices/listings';
import MainCard from './MainCard';
import AddIcon from '@mui/icons-material/AddTwoTone';
import SearchIcon from '@mui/icons-material/Search';
import useAuth from 'hooks/useAuth';
import useDebounce from 'hooks/useDebounce';
import useTable, { getComparator } from 'hooks/useTable';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { propertyStatus, roles } from 'store/constant';
import { openConfirmationModal } from 'store/slices/confirmationModal';
import { EmployeeActions } from 'store/slices/employees';
import { openSnackbar } from 'store/slices/snackbar';
import { TermsActions } from 'store/slices/Terms&Condition';
import EmptyContent from 'ui-component/extended/EmptyContent';
import SkeletonDocument from 'ui-component/skeleton/SkeletonDocuments';
import { findKeyInObject } from 'utils/findKeyInObjects';
import { applySortFilter } from 'views/attendance/leave';
import DetailsModal from './DetailsModal';
import EnhancedTableHead from './ListingTableHead';
import ListingTableRow from './ListingTableRow';
import ShareAccess from './ShareAccess';
import TermModal from './TermModal';
import { complexSpecificDuplicate } from './validation';
import './CustomScrollbar.css';
import {
    clearManageListingFilters,
    setManageListingFilters,
    toggleArchieveBtnTrue,
    toggleCreateBtnFalse,
    toggleCreateBtnTrue
} from 'store/slices/customActions';

const ManageListing = () => {
    const [searchParams] = useSearchParams();

    const { listings, loading, totalData, count, complexDropdown, floorPlanDropdown } = useSelector((state) => state.listings);
    const { createEmptyListings, fetchAllListings, deleteListings, verifyListings, getCount, editListingStatus, duplicateListings } =
        ListingActions;

    const [openTerms, setOpenTerms] = useState(false);
    const [termsReqSend, setTermsReqSend] = useState(false);

    const { fetchEmployeeContacts, editSettings } = EmployeeActions;
    const { role, user } = useAuth();
    const { terms } = useSelector((state) => state.Terms);
    const { search, selectedAM, selectedFilter, selectedComplex, selectedFloorPlan } = useSelector(
        (state) => state.customActions.manageListing
    );
    const { fetchAllTerms } = TermsActions;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [selectedValue, setSelectedValue] = useState(0);
    const theme = useTheme();
    const [tableData, setTableData] = useState([]);
    const [selectedRow, setSelectedRow] = useState();
    const [openDetails, setOpenDetails] = useState(false);
    const [openShareAccess, setOpenShareAccess] = useState({ open: false, id: '' });
    // const [search, setSearch] = useState(null);
    // const [selectedAM, setSelectedAM] = useState(null);
    const [allAMS, setAllAMS] = useState([]);
    const debouncedSearch = useDebounce(search, 500);
    const customActions = useSelector((state) => state.customActions);

    const getListingStatus = () => {
        if (selectedValue === 1) {
            return 'PUBLISHED';
        }
        if (selectedValue === 2) {
            return 'DRAFT';
        }
        if (selectedValue === 0) {
            return 'ALL';
        }
    };

    const allFilters = ['Floor Plan', 'Complex Name', 'Unit Id', 'Listing Price', 'Photos'];

    // const [selectedFilter, setSelectedFilter] = useState(null);
    // const [selectedComplex, setSelectedComplex] = useState(null);
    // const [selectedFloorPlan, setSelectedFloorPlan] = useState(null);
    const [progress, setProgress] = useState(0);
    const [baseData, setBaseData] = useState([]);
    const tableRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    // console.log(useSelector((state) => state.customActions.manageListing));

    const {
        page,
        order,
        orderBy,
        rowsPerPage,
        setPage,
        selected,
        setSelected,
        onSelectRow,
        onSelectAllRows,
        setOrder,
        setOrderBy,
        // onSort,
        onChangePage,
        onChangeRowsPerPage
    } = useTable();

    const onSort = (id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };

    const detailedView = (row) => {
        setOpenDetails(true);
        setSelectedRow(row);
    };

    const fetchDataAfterMultiDelete = () => {
        dispatch(fetchAllListings({ page: page + 1, limit: rowsPerPage, search }));
    };

    const handleApproveRequest = async (row) => {
        const data = { property_id: row?.id, listingStatus: 'APPROVED' };

        dispatch(
            openConfirmationModal({
                open: true,
                message: 'Please click on submit to approve the property',
                listingNumber: row?.listing_id ? row?.listing_id : row?.id?.slice(-5),
                islistingNumber: !!row?.listing_id,
                handleConfirm: async (listNumber) => {
                    const newData = {
                        ...data
                        // listingId: listNumber
                    };

                    const res = await dispatch(verifyListings({ values: newData }));
                    if (res?.payload?.status === 201 || res?.payload?.status === 200) {
                        dispatch(
                            openSnackbar({
                                open: true,
                                message: 'Property approved successfully',
                                variant: 'alert',
                                alert: {
                                    color: 'success'
                                },
                                close: true
                            })
                        );
                        dispatch(fetchAllListings({ page: page + 1, limit: rowsPerPage, search }));
                    } else {
                        dispatch(
                            openSnackbar({
                                open: true,
                                message:
                                    findKeyInObject(res?.payload, `message`) ||
                                    findKeyInObject(res?.payload, `error`) ||
                                    'Internal server error',
                                variant: 'alert',
                                alert: {
                                    color: 'error'
                                },
                                close: true
                            })
                        );
                    }
                }
            })
        );
    };

    const handleRejectRequest = async (row) => {
        const data = { property_id: row?.id, listingStatus: 'REJECTED' };
        dispatch(
            openConfirmationModal({
                open: true,
                message: 'Please click on submit to reject the property',
                listingNumber: row?.listing_id ? row?.listing_id : row?.id?.slice(-5),
                islistingNumber: !!row?.listing_id,
                handleConfirm: async (listNumber) => {
                    const newData = {
                        ...data
                        // listingId: listNumber
                    };
                    const res = await dispatch(verifyListings({ values: newData }));
                    if (res?.payload?.status === 201 || res?.payload?.status === 200) {
                        dispatch(
                            openSnackbar({
                                open: true,
                                message: 'Property rejected successfully',
                                variant: 'alert',
                                alert: {
                                    color: 'success'
                                },
                                close: true
                            })
                        );
                        dispatch(fetchAllListings({ page: page + 1, limit: rowsPerPage, search }));
                    } else {
                        dispatch(
                            openSnackbar({
                                open: true,
                                message:
                                    findKeyInObject(res?.payload, `message`) ||
                                    findKeyInObject(res?.payload, `error`) ||
                                    'Internal server error',
                                variant: 'alert',
                                alert: {
                                    color: 'error'
                                },
                                close: true
                            })
                        );
                    }
                }
            })
        );
    };

    const handleArchieve = async (row) => {
        const data = {
            id: row?.id,
            values: {
                status: propertyStatus.ARCHIEVED
            }
        };
        dispatch(
            openConfirmationModal({
                open: true,
                message: 'Please click on submit to archive the property',
                handleConfirm: async (listNumber) => {
                    // const newData = {
                    //     ...data,
                    //     listingId: listNumber
                    // };
                    const res = await dispatch(editListingStatus(data));
                    await dispatch(getCount());
                    if (res?.payload?.status === 201 || res?.payload?.status === 200) {
                        dispatch(
                            openSnackbar({
                                open: true,
                                message: 'Property archived successfully',
                                variant: 'alert',
                                alert: {
                                    color: 'success'
                                },
                                close: true
                            })
                        );
                        dispatch(fetchAllListings({ page: page + 1, limit: rowsPerPage, search }));
                    } else {
                        dispatch(
                            openSnackbar({
                                open: true,
                                message:
                                    findKeyInObject(res?.payload?.error, `message`) ||
                                    findKeyInObject(res?.payload?.error, `error`) ||
                                    'Internal server error',
                                variant: 'alert',
                                alert: {
                                    color: 'error'
                                },
                                close: true
                            })
                        );
                    }
                }
            })
        );
    };

    const handleDelete = async (Id) => {
        const object = {
            properties: [Id]
        };

        dispatch(
            openConfirmationModal({
                open: true,
                message: 'Are you sure you want to delete',
                islistingNumber: true,
                handleConfirm: async () => {
                    const res = await dispatch(deleteListings(object));

                    if (res?.payload?.status !== 201 && res?.payload?.status !== 200) {
                        dispatch(
                            openSnackbar({
                                open: true,
                                message: res?.payload?.message || 'Internal server error',
                                variant: 'alert',
                                alert: {
                                    color: 'error'
                                },
                                close: true
                            })
                        );
                    } else {
                        dispatch(
                            openSnackbar({
                                open: true,
                                message: 'Properties deleted successfully',
                                variant: 'alert',
                                alert: {
                                    color: 'success'
                                },
                                close: true
                            })
                        );
                        dispatch(fetchAllListings({ page: page + 1, limit: rowsPerPage, search: null }));
                    }
                }
            })
        );
    };

    const createNewEmptyLisitng = async () => {
        try {
            const res = await dispatch(createEmptyListings({}));

            if (res?.payload?.status === 200 || res?.payload?.status === 201) {
                navigate(`/listing/${res?.payload?.data?.id}`);
            } else {
                dispatch(
                    openSnackbar({
                        open: true,
                        message:
                            findKeyInObject(res?.payload, `message`) ||
                            findKeyInObject(res?.payload, `error`) ||
                            `Oops! Something went wrong.`,
                        variant: 'alert',
                        alert: {
                            color: 'error'
                        },
                        close: true
                    })
                );
            }
        } catch (e) {
            dispatch(
                openSnackbar({
                    open: true,
                    message:
                        findKeyInObject(res?.payload, `message`) || findKeyInObject(res?.payload, `error`) || `Oops! Something went wrong.`,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: true
                })
            );
        }
    };

    const dataFiltered = applySortFilter({
        tableData: tableData?.map((row) => ({
            ...row,
            specialAccessUserNames: row?.specialUserAccess
                ?.filter((e) => e?.user?.roleName === roles.APARTMENT_MANAGER)
                ?.map((e) => `${e?.user?.firstName} ${e?.user?.lastName}`)
                .join(', ')
        })),
        comparator: getComparator(order, orderBy)
    });

    function filterNestedObject(obj, keys) {
        const result = {};

        function filterHelper(currentObj, currentResult) {
            for (const key in currentObj) {
                if (keys.includes(key)) {
                    currentResult[key] = currentObj[key];
                } else if (typeof currentObj[key] === 'object' && !Array.isArray(currentObj[key])) {
                    currentResult[key] = {};
                    filterHelper(currentObj[key], currentResult[key]);
                    // Remove empty objects
                    if (Object.keys(currentResult[key]).length === 0) {
                        delete currentResult[key];
                    }
                }
            }
        }

        filterHelper(obj, result);
        return result;
    }

    const createNewComplexDuplicateLisitng = async (initialValues) => {
        try {
            const filteredObject = filterNestedObject(initialValues, complexSpecificDuplicate);

            // Add the completion key-value pair
            filteredObject.completion = 72;

            // Remove the 'lister' key
            delete filteredObject.lister;

            const res = await dispatch(createEmptyListings(filteredObject));

            if (res?.payload?.status === 200 || res?.payload?.status === 201) {
                navigate(`/listing/${res?.payload?.data?.id}`);
            } else {
                dispatch(
                    openSnackbar({
                        open: true,
                        message:
                            findKeyInObject(res?.payload, `message`) ||
                            findKeyInObject(res?.payload, `error`) ||
                            `Oops! Something went wrong.`,
                        variant: 'alert',
                        alert: {
                            color: 'error'
                        },
                        close: true
                    })
                );
            }
        } catch (e) {
            // // console.log({ e });
            dispatch(
                openSnackbar({
                    open: true,
                    // message:
                    //     findKeyInObject(res?.payload, `message`) || findKeyInObject(res?.payload, `error`) || `Oops! Something went wrong.`,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: true
                })
            );
        }
    };

    const createNewEntireDuplicateLisitng = async (id) => {
        dispatch(
            openConfirmationModal({
                open: true,
                message: 'Are you sure you want to create a new listing?',
                islistingNumber: true,
                handleConfirm: async () => {
                    const res = await dispatch(duplicateListings(id));

                    if (res?.payload?.status !== 201 && res?.payload?.status !== 200) {
                        dispatch(
                            openSnackbar({
                                open: true,
                                message: res?.payload?.message || 'Internal server error',
                                variant: 'alert',
                                alert: {
                                    color: 'error'
                                },
                                close: true
                            })
                        );
                    } else {
                        dispatch(fetchAllListings({ page: page + 1, limit: rowsPerPage, search, managerId: selectedAM }));

                        dispatch(
                            openSnackbar({
                                open: true,
                                message: 'New Property Created successfully',
                                variant: 'alert',
                                alert: {
                                    color: 'success'
                                },
                                close: true
                            })
                        );
                        navigate('/listing/manage-listing');
                        // navigate(`/listing/${res?.payload?.data?.id}`);
                    }
                }
            })
        );
    };

    const handleEdit = (row) => {
        if (row.listingStatus === 'PENDING' || row.listingStatus === 'NONE') {
            navigate(`/listing/${row?.id}`);
        } else {
            dispatch(
                openConfirmationModal({
                    open: true,
                    message: 'Are you sure you wish to modify your approved listing?',
                    handleConfirm: async () => {
                        navigate(`/listing/${row?.id}`);
                    }
                })
            );
        }
    };
    const handleAnalyticsOpen = (row) => {
        navigate(`/dashboard/analytics/${row?.id}`);
    };
    const handleClearFilter = async () => {
        await dispatch(clearManageListingFilters());
        setOrderBy('');
        setOrder('');
    };

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStartX(e.pageX - tableRef.current.offsetLeft);
        setScrollLeft(tableRef.current.scrollLeft);
    };

    const handleMouseLeaveOrUp = () => {
        setIsDragging(false);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - tableRef.current.offsetLeft;
        const walk = (x - startX) * 2; // Adjust the multiplier for scroll speed
        tableRef.current.scrollLeft = scrollLeft - walk;
    };

    // console.log(customActions);

    useEffect(() => {
        if (customActions.isCreateBtnClicked === true) {
            setOrder('desc');
            setOrderBy('createdAt');
            dispatch(toggleCreateBtnFalse());
        } else {
            setOrder('asc');
            setOrderBy('status');
        }
    }, []);

    useEffect(() => {
        if (loading) {
            const interval = setInterval(() => {
                setProgress((oldProgress) => {
                    const randomIncrement = Math.random() * 33;
                    const newProgress = Math.min(oldProgress + randomIncrement, 95);
                    return newProgress;
                });
            }, 500);

            return () => {
                clearInterval(interval);
            };
        }
    }, [loading]);

    useEffect(() => {
        let filterParam = '';
        if (selectedFilter) {
            if (selectedFilter === 'Floor Plan') {
                filterParam = 'generalInformation->floorPlanName';
            } else if (selectedFilter === 'Complex Name') {
                filterParam = 'generalInformation->complexName';
            } else if (selectedFilter === 'Unit Id') {
                filterParam = 'locationInformation->unit';
            } else if (selectedFilter === 'Listing Price') {
                filterParam = 'listingInformation->listPrice';
            } else if (selectedFilter === 'Photos') {
                filterParam = 'attachments';
            }
        }

        setProgress(0);

        dispatch(
            fetchAllListings({
                page: page + 1,
                limit: rowsPerPage,
                search,
                managerId: selectedAM,
                filters: filterParam || '',
                complex: selectedComplex,
                floorPlan: selectedFloorPlan,
                sortByKey: orderBy !== '' && orderBy !== 'name' ? orderBy : null,
                sortByType: order !== '' ? order : null,
                listingStatus: getListingStatus()
            })
        );
    }, [order, orderBy, page, rowsPerPage, debouncedSearch, selectedAM, selectedFilter, selectedComplex, selectedFloorPlan, selectedValue]);

    useEffect(() => {
        dispatch(fetchAllTerms());
    }, []);

    useEffect(() => {
        dispatch(fetchEmployeeContacts({ search: '' })).then((data) => {
            setAllAMS(data?.payload?.primaryData);
        });

        const am = searchParams.get('am');
        if (am) {
            dispatch(setManageListingFilters({ selectedAM: am || null }));
            // setSelectedAM(am);
        }
    }, [searchParams]);

    useEffect(() => {
        setTableData(listings);
    }, [listings]);

    useEffect(() => {
        if (listings?.length > 0) {
            setBaseData(listings);
        }
    }, [listings]);

    const nav = useNavigate();

    return (
        <>
            <TermModal
                open={openTerms}
                setOpen={setOpenTerms}
                handleOpen={() => {
                    setOpenTerms(true);
                }}
                handleClose={() => {
                    setOpenTerms(false);
                }}
                setReqSend={setTermsReqSend}
            />

            <Breadcrumbs heading="Listings" links={[{ name: 'Listings', href: '/listing/manage-listing' }]} />
            <DetailsModal open={openDetails} setOpen={setOpenDetails} selectedRow={selectedRow} />
            <MainCard
                title="All Listings"
                element={
                    <Stack direction="row" gap={1} flexWrap="wrap" justifyContent="flex-end" alignItems="center" sx={{ mx: 2 }}>
                        <Tooltip title="Add New Listing">
                            <Fab
                                size="small"
                                variant="extended"
                                onClick={() => {
                                    dispatch(toggleCreateBtnTrue());
                                    createNewEmptyLisitng();
                                }}
                                sx={{
                                    boxShadow: 'none',
                                    p: 1,
                                    minHeight: 32,
                                    color: '#fff',
                                    borderRadius: '5px',
                                    py: '22px',
                                    bgcolor: theme.palette.secondary.main,
                                    '&:hover': { bgcolor: theme.palette.secondary.dark }
                                }}
                            >
                                <AddIcon fontSize="small" />
                                &nbsp;Create Listing&nbsp;
                            </Fab>
                        </Tooltip>
                    </Stack>
                }
                contentSX={{ p: 0 }}
            >
                {loading && (
                    <div style={{ position: 'relative', marginBottom: theme.spacing(2) }}>
                        <LinearProgress
                            variant="determinate"
                            value={progress}
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: 4,
                                borderRadius: '4px',
                                border: `1px solid ${theme.palette.divider}`,
                                zIndex: 1,

                                ' .MuiLinearProgress-bar': {
                                    backgroundColor: '#0E7AF0'
                                }
                            }}
                        />
                    </div>
                )}
                <CardContent>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            mb: 4,
                            gap: 3,
                            textAlign: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                mb: 4,
                                gap: 3,
                                textAlign: 'center'
                            }}
                        >
                            <Box
                                onClick={() => {
                                    setSelectedValue(0);
                                }}
                                sx={{
                                    bgcolor: selectedValue === 0 ? '#EEF2F6' : 'white',
                                    fontWeight: selectedValue === 0 ? 'bold' : 'normal',
                                    borderRadius: '10px',
                                    fontWeight: 'bold',
                                    padding: '0 10px',
                                    height: '38px',
                                    border: selectedValue === 0 ? '2px solid #E0E0E0' : 'none',
                                    borderRadius: '4px',
                                    marginInline: '2px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer'
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <Typography>All</Typography>
                                    <Typography sx={{ background: 'black', px: '10px', py: '2px', borderRadius: '6px', color: 'white' }}>
                                        {(count?.totalPublishedProperties || 0) + (count?.totalUnpublishedProperties || 0)}
                                    </Typography>
                                </Box>
                            </Box>

                            <Box sx={{ background: '#ECECEC', width: '1px', height: '39px' }} />
                            <Box
                                onClick={() => {
                                    setSelectedValue(1);
                                }}
                                sx={{
                                    bgcolor: selectedValue === 1 ? '#EEF2F6' : 'white',
                                    fontWeight: selectedValue === 1 ? 'bold' : 'normal',
                                    borderRadius: '10px',
                                    fontWeight: 'bold',
                                    padding: '0 10px',
                                    justifySelf: 'center',
                                    alignSelf: 'center',
                                    minWidth: 'unset',
                                    minHeight: 'unset',
                                    height: '38px',
                                    border: selectedValue === 1 ? '2px solid #E0E0E0' : 'none',
                                    borderRadius: '4px',
                                    marginInline: '2px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    justifyContent: 'center'
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <Typography>Published</Typography>
                                    <Typography
                                        sx={{ background: '#BDE2BA', px: '10px', py: '2px', borderRadius: '6px', color: '#319A28' }}
                                    >
                                        {count?.totalPublishedProperties || 0}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box sx={{ background: '#ECECEC', width: '1px', height: '39px' }} />
                            <Box
                                onClick={() => {
                                    setSelectedValue(2);
                                }}
                                sx={{
                                    bgcolor: selectedValue === 2 ? '#EEF2F6' : 'white',
                                    fontWeight: selectedValue === 2 ? 'bold' : 'normal',
                                    borderRadius: '10px',
                                    fontWeight: 'bold',
                                    padding: '0 10px',
                                    justifySelf: 'center',
                                    alignSelf: 'center',
                                    justifyContent: 'center',
                                    minWidth: 'unset',
                                    minHeight: 'unset',
                                    height: '38px',
                                    border: selectedValue === 2 ? '2px solid #E0E0E0' : 'none',
                                    borderRadius: '4px',
                                    marginInline: '2px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    cursor: 'pointer'
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <Typography>Draft</Typography>
                                    <Typography
                                        sx={{ background: '#FFF2DC', px: '10px', py: '2px', borderRadius: '6px', color: '#AD7126' }}
                                    >
                                        {count?.totalUnpublishedProperties || 0}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>

                        <Button
                            onClick={() => {
                                dispatch(toggleArchieveBtnTrue());
                                nav('/listing/archived-listing');
                            }}
                            variant="outlined"
                        >
                            Archieved listings
                        </Button>
                    </Box>

                    <Box sx={{ display: 'flex', width: '100%' }} direction="row" gap={1} alignItems="center">
                        {/* Search TextField */}
                        <Box sx={{ display: 'flex', gap: 1, width: '85%' }}>
                            <TextField
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon fontSize="small" sx={{ color: '#462F4D' }} />
                                        </InputAdornment>
                                    ),
                                    sx: {
                                        borderRadius: '8px',
                                        padding: '6px'
                                    }
                                }}
                                fullWidth
                                variant="outlined"
                                value={search}
                                size="small"
                                onChange={(e) => {
                                    dispatch(setManageListingFilters({ search: e?.target?.value || '' }));
                                }}
                                placeholder="Search By Complex Name, Listing ID and Address"
                            />

                            {role !== roles.APARTMENT_MANAGER && (
                                <Autocomplete
                                    fullWidth
                                    id="employement_type"
                                    options={allAMS?.filter((am) => am?.status === 'VERIFIED') || []}
                                    getOptionLabel={(option) => (option?.firstName ? `${option.firstName} ${option.lastName}` : '')} // only name
                                    value={allAMS?.find((am) => am?.id === selectedAM) || null}
                                    onChange={(e, newValue) => dispatch(setManageListingFilters({ selectedAM: newValue?.id || null }))}
                                    renderInput={(params) => <TextField {...params} label="Select Manager" />}
                                    renderOption={(props, option) => (
                                        <Box
                                            {...props}
                                            sx={{
                                                display: 'flex !important',
                                                flexDirection: 'column !important',
                                                alignItems: 'start !important',
                                                textAlign: 'left !important',
                                                justifyContent: 'start !important'
                                            }}
                                        >
                                            <Typography variant="subtitle1" sx={{ textTransform: 'capitalize' }}>
                                                {`${option.firstName} ${option.lastName}`}
                                            </Typography>
                                        </Box>
                                    )}
                                />
                            )}
                            {role === roles.ADMIN && (
                                <Autocomplete
                                    fullWidth
                                    id="employement_type"
                                    options={allFilters || []}
                                    value={allFilters?.find((am) => am === selectedFilter) || null}
                                    onChange={(e, newValue) => dispatch(setManageListingFilters({ selectedFilter: newValue || null }))}
                                    renderInput={(params) => <TextField {...params} label="Last Update By" />}
                                    renderOption={(props, option) => (
                                        <Box
                                            {...props}
                                            sx={{
                                                display: 'flex !important',
                                                flexDirection: 'column !important',
                                                alignItems: 'start !important',
                                                textAlign: 'left !important',
                                                justifyContent: 'start !important'
                                            }}
                                        >
                                            <Typography variant="subtitle1" sx={{ textTransform: 'capitalize' }}>
                                                {option}
                                            </Typography>
                                        </Box>
                                    )}
                                />
                            )}
                            <Autocomplete
                                fullWidth
                                id="employement_type"
                                options={complexDropdown || []}
                                value={complexDropdown?.find((am) => am === selectedComplex) || null}
                                onChange={(e, newValue) => dispatch(setManageListingFilters({ selectedComplex: newValue }))}
                                renderInput={(params) => <TextField {...params} label="Select Complex" />}
                                renderOption={(props, option) => (
                                    <Box
                                        {...props}
                                        sx={{
                                            display: 'flex !important',
                                            flexDirection: 'column !important',
                                            alignItems: 'start !important',
                                            textAlign: 'left !important',
                                            justifyContent: 'start !important'
                                        }}
                                    >
                                        <Typography variant="subtitle1" sx={{ textTransform: 'capitalize' }}>
                                            {option}
                                        </Typography>
                                    </Box>
                                )}
                            />
                            <Autocomplete
                                fullWidth
                                id="employement_type"
                                options={floorPlanDropdown || []}
                                value={floorPlanDropdown?.find((am) => am === selectedFloorPlan) || null}
                                onChange={(e, newValue) => dispatch(setManageListingFilters({ selectedFloorPlan: newValue }))}
                                renderInput={(params) => <TextField {...params} label="Select Floor Plan" />}
                                renderOption={(props, option) => (
                                    <Box
                                        {...props}
                                        sx={{
                                            display: 'flex !important',
                                            flexDirection: 'column !important',
                                            alignItems: 'start !important',
                                            textAlign: 'left !important',
                                            justifyContent: 'start !important'
                                        }}
                                    >
                                        <Typography variant="subtitle1" sx={{ textTransform: 'capitalize' }}>
                                            {option}
                                        </Typography>
                                    </Box>
                                )}
                            />
                        </Box>

                        {role !== roles.APARTMENT_MANAGER && (
                            <Tooltip title="Clear Filters">
                                <Button onClick={handleClearFilter}>
                                    <Typography
                                        align="left"
                                        variant="subtitle1"
                                        component="div"
                                        sx={{ color: '#0E7AF0', fontWeight: '600', fontSize: '12px' }}
                                    >
                                        Clear Filters
                                    </Typography>

                                    <CloseIcon sx={{ marginLeft: '5px', color: '#0E7AF0', fontSize: '12px' }} />
                                </Button>
                            </Tooltip>
                        )}
                    </Box>

                    <ShareAccess
                        openDialog={openShareAccess?.open}
                        handleCloseDialog={() => {
                            setOpenShareAccess({ open: false, id: '' });
                        }}
                        listingId={openShareAccess?.id}
                    />
                </CardContent>

                <TableContainer
                    sx={{ mt: 3 }}
                    style={{ maxWidth: '100%', overflowX: 'auto', cursor: isDragging ? 'grabbing' : 'grab' }}
                    ref={tableRef}
                    onMouseDown={handleMouseDown}
                    onMouseMove={handleMouseMove}
                    onMouseUp={handleMouseLeaveOrUp}
                    onMouseLeave={handleMouseLeaveOrUp}
                    className="custom-scrollbar"
                >
                    <Table>
                        <EnhancedTableHead
                            numSelected={selected?.length}
                            order={order}
                            orderBy={orderBy}
                            setSelected={setSelected}
                            onSelectAllClick={(checked) =>
                                onSelectAllRows(
                                    checked,
                                    tableData?.map((row) => row.id)
                                )
                            }
                            selected={selected}
                            onSort={onSort}
                            fetchDataAfterMultiDelete={fetchDataAfterMultiDelete}
                            rowCount={tableData?.length}
                            theme={theme}
                        />
                        <TableBody>
                            {loading && baseData?.length === 0
                                ? [1, 2, 3, 4, 5].map((ele, index) => <SkeletonDocument key={ele + index} />)
                                : (loading ? baseData : dataFiltered).map((row, index) => (
                                      <ListingTableRow
                                          key={row?.id}
                                          row={row}
                                          index={page * rowsPerPage + index}
                                          selected={selected}
                                          onSelectRow={onSelectRow}
                                          detailedView={detailedView}
                                          handleApproveRequest={handleApproveRequest}
                                          handleRejectRequest={handleRejectRequest}
                                          handleArchieve={handleArchieve}
                                          handleDelete={handleDelete}
                                          handleEdit={handleEdit}
                                          createNewComplexDuplicateLisitng={createNewComplexDuplicateLisitng}
                                          createNewEntireDuplicateLisitng={createNewEntireDuplicateLisitng}
                                          myData={row?.lister_id === user?.id}
                                          terms={terms}
                                          setOpenTerms={setOpenTerms}
                                          termsReqSend={termsReqSend}
                                          openShareAccess={(e) => {
                                              setOpenShareAccess({ open: true, id: e });
                                          }}
                                          handleAnalyticsOpen={handleAnalyticsOpen}
                                      />
                                  ))}
                        </TableBody>
                    </Table>
                    {!loading && listings?.length === 0 && <EmptyContent title="No Lisings found!" />}
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[25, 50, 100]}
                    component="div"
                    count={totalData || 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={onChangePage}
                    onRowsPerPageChange={onChangeRowsPerPage}
                />
            </MainCard>
        </>
    );
};

export default ManageListing;
